<template>
  <ControlUnit :title="$t('control.panel.scale')">
    <InputRange
      :name="unitName"
      :value="currentAvatarScale"
      :options="avatarScale"
      @change="changeHandler"
    />
  </ControlUnit>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';

import { runAllWithData } from '@/helpers/functional';

import useStateController from './useStateController';
import useRouteController from './useRouteController';

import ControlUnit from './ControlUnit.vue';
import InputRange from './InputRange.vue';

export default {
  components: {
    ControlUnit,
    InputRange,
  },
  setup() {
    const unitName = 'avatar-scale';

    const store = useStore();

    const avatarScale = store.state.control.avatarScale;

    const currentAvatarScale = computed(() => {
      return store.state.control.avatarScale.current;
    });

    const { changeControlHandler } = useStateController();

    const { setRouteTypeValue, getRouterQueryValue } =
      useRouteController('Control');

    const changeHandler = runAllWithData(
      changeControlHandler,
      setRouteTypeValue
    );

    onMounted(() => {
      const unitQueryValue = getRouterQueryValue(unitName);
      const numberValue = Number(unitQueryValue) || null;

      changeControlHandler({
        type: unitName,
        value: numberValue || currentAvatarScale.value,
      });
    });

    return {
      unitName,
      avatarScale,
      currentAvatarScale,
      changeHandler,
    };
  },
};
</script>
